export const Orders = {
  title: 'Pedidos em Curso',
  labelOrder: 'Pedido',
  labelPackage: 'Encomenda',
  labelUser: 'Cliente',
  labelState: 'Estado',
  resultSubtitle: 'Resultados',
  datePlaceholder: 'Seleccione Data de Inicio / Data de Fim',
  orderByChoiseUser1: 'Ordernar por: Data de Entrega',
  orderByChoiseUser2: 'Ordernar por: Código Postal',
  orderByChoise1: 'Data de Entrega',
  orderByChoise2: 'Código Postal',
  exportExcelFile: 'Exportar excel',
  exportCsvFile: 'Exportar csv',
  noResults: 'Não foram encontrados resultados para os critérios de pesquisa seleccionados.',
  results: 'Resultados',
  labelNumOrder: 'Pedido',
  pyxisCreation: 'Criação Pyxis',
  supplierID: 'Nº Fornecedor',
  availability: 'Disponibilidade',
  orderId: 'Nº Pedido BO',
  delivery: 'Entrega {date}',
  deliveryDate: 'Entrega a',
  alreadyDeliveryDate: 'Foi entrega a',
  numberVolumes: 'Nº de Volumes',
  labelWeight: 'Peso/Volume',
  type: 'Tipo',
  customerName: 'Nome',
  customerPhone: 'Contacto',
  postalCode: 'C. Postal',
  obs: 'Obs.',
  NumOrder: 'Pedido Nº {value}',
  clientDetails: 'Detalhes do Cliente',
  orderDate: 'Data Pedido',
  numVolumes: 'Nº de Volumes',
  numPallet: 'Nº de Paletes',
  equivalentNumberPallet: 'Nº de Paletes Equivalentes',
  normalEquivalentPallet: '= Nº Paletes Normais',
  volume: 'Volume (m<sup>3</sup>)',
  deliveryType: 'Tipo de Entrega',
  helper: 'Ajudante Extra?',
  installation: 'Montagem',
  userName: 'Nome do Cliente',
  email: 'E-mail',
  phone: 'Contacto Telefonico',
  address: 'Morada de Entrega',
  pCode: 'Código Postal',
  city: 'Localidade',
  store: 'Loja',
  collectPoint: 'Local de Recolha',
  plate: 'Matrícula',
  collection: 'Recolha',
  collectionInformation: 'Informações sobre a Recolha',
  MORNING: 'MANHÃ',
  AFTERNOON: 'TARDE',
  YES: 'Sim',
  NO: 'Não',
  observations: 'Observações',
  volumeWeight: '{weight}kg / {volume}m<sup>3</sup>',
  deliveryPeriod: 'Periodo de Entrega',
  tooltipOp1: 'Imprimir etiquetas',
  tooltipOp2: 'Pedido Pronto',
  tooltipOp3: 'Restaurar Pedido',
  tooltipOp4: 'Artigos do Pedido',
  tooltipOp5: 'Editar Pedido',
  tooltipOp6: 'Pedido Precisa de ser Comunicado para se poder Imprimir Etiquetas',
  tooltipOp7: 'Pedido ainda não pode ser Comunicado',
  tooltipOp8: 'Confirmar Pedido Cancelado',
  tooltipOp9: 'Rejeitar Pedido',
  tooltipOp10: 'Preparar pedido',
  CANCELED: 'Anulado',
  IN_PROGRESS: 'Em Curso',
  collectionRequest: 'Pedido de Recolha',
  expectedCollection: 'Previsão de Recolha',
  confirmedCollection: 'Confirmação de Recolha',
  partnerCollect: 'Expedição',
  partner: 'Transportadora',
  PENDENT: 'Pedido Pendente',
  REPORTED: 'Pedido Reportado',
  ERROR_COMMUNICATING: 'Erro de comunicação',
  ERROR_NEWOFFERPICKUP: 'Erro de comunicação',
  INVALID_FIELDS: 'Campos Inválidos',
  CHANGED_DATE: 'Pedido com Data de Entrega Alterada pela Transportadora',
  CONSULTED: 'Pedido Consultado',
  AWAITS_CONFIRMATION: 'Aguarda Confirmação',
  TO_REJECT: 'Rejeitado',
  REJECTED: 'Rejeição Confirmada',
  IN_PREPARATION: 'Em Preparação',
  AWAITS_DISPATCH: 'Aguarda Expedição',
  ON_EXPEDITION: 'Em Expedição',
  DELIVERED: 'Entregue',
  COMPLETED: 'Concluído',
  movimentaState: 'Estado Movimenta'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/Orders.js